import { RouteConfig } from 'vue-router'

const router: Array<RouteConfig> = [

  {
    path: '/deviceList',
    name: 'deviceList',
    component: () => import('@/views/device/DeviceList.vue')
  },
  {
    path: '/deviceAdd',
    name: 'deviceAdd',
    component: () => import('@/views/device/DeviceAdd.vue')
  },
  {
    path: '/garbageStation',
    name: 'garbageStation',
    component: () => import('@/views/device/GarbageStation.vue')
  },
  {
    path: '/deviceList/deviceDetail/:deviceId',
    name: 'deviceDetail',
    component: () => import('@/views/device/DeviceDetail.vue'),
    redirect: '/deviceList/deviceDetail/:deviceId/base',
    children: [
      {
        path: 'base',
        props: true,
        component: () => import('@/views/device/Base.vue')
      },
      {
        path: 'location',
        component: () => import('@/views/device/Location.vue')
      },
      {
        path: 'config',
        props: true,
        component: () => import('@/views/device/Config.vue')
      },
      {
        path: 'record',
        props: true,
        component: () => import('@/views/device/Record.vue')
      },
      {
        path: 'history',
        props: true,
        component: () => import('@/views/device/History.vue')
      },
      {
        path: 'network',
        props: true,
        component: () => import('@/views/device/Network.vue')
      }
    ]
  }
]

export default router
